import ArchiveGallery from "./ArchiveGallery";

function Wallpaper() {
  return (
    <ArchiveGallery
      category="wallpaper"
      showCollectionFilter={false}
      emptyTitle="No wallpaper found in this section."
    />
  );
}

export default Wallpaper;
